const laosPhotos = {
    id: 'luang-prabang',
    type: 'photoPost',
    countryId: 'seAsia',
    title: 'Luang Prabang in Photos',
    month: 'Jan',
    date: '20',
    content: [
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP1.jpg',
            detailText: 'The night market in the rain, next to one of the beautiful wood and gold temples.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP2.jpg',
            detailText: 'Bars and restaurants light up with lots of fairy lights and lanterns at night. Our favorite two were Lao Lao Garden and Utopia.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP3.jpg',
            detailText: 'We walked up to the temple on Phousi Mountain through Wat Siphoutthabath.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP5.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP6.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP7.jpg',
            detailText: 'Luang Prabang from the hilltop temple in the center of town.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP13.jpg',
            detailText: 'And the other side of the city.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP8.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP9.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP10.jpg'],
            detailText: 'The walk up Phousi Mountain.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP11.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP12.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP14.jpg',
            detailText: 'Our boat tour down the Mekong.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP15.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP16.jpg',
            detailText: 'Pak Ou caves lit up by candles.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP17.jpg',
            detailText: 'Cute cats everywhere, including in caves!'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP18.jpg',
            detailText: 'The view from the caves.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP19.jpg',
            detailText: 'Lao lao, the national drink of Laos! It\'s a liquer-like drink made from sticky rice and drunk in small amounts (with or without snakes).'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw1.jpg',
            detailText: 'The stunning falls at Kuang Si (this and next 6 pictures).'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw3.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw5.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw6.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LPw7.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP20.jpg',
            detailText: 'This was the size of a hand. Don\'t worry, we\'re farther away than we look.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP21.jpg',
            detailText: 'On the way to Tae Sae waterfall.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP22.jpg',
            detailText: 'Tad Sae waterfall. It\'s similar to Kuang Si but not quite as blue or impressive, though beautiful in the sunset light.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP23.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/luangprabang/LP24.jpg'],
            detailText: 'Alice at Tad Sae, and Luang Prabang in the rain with a flag we see in both Vietnam and Laos.'
        }
    ]
}


export default laosPhotos


// WEBPACK FOOTER //
// ./src/Posts/Content/LaosPhotos.js